export const SHOPIFY_STOREFRONT_API_VERSION = "2026-07"
